export const environment = {
  envName: 'dev',
  production: false,
  tagManagerEnv: 'env-3',
  tagManagerAuth: '-_rR6Zjc4bAOeaGltsAgvA',
  apiUrl: 'https://mcgrawhillebookdev.mheducation.com/api',
  enablePendo: false,
};
